import React, { useState, useEffect } from 'react';
import  { Container, Row, Col, Button,  Breadcrumb } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../page-layout/header/Header';
import NavMenu from '../navigation/Navmenu';
import Footer from '../page-layout/footer/Footer';
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { columns, data } from '../data/data_m';
import moment from 'moment';
import { ConfirmAlert, TimerAlert } from '../../utils/swtAlert';
import { DeleteIndustryType, GetIndustryType } from '../../utils/axios/LookUpAPI';
import { GrokLoading } from "../page-layout/loading/Loading";


const IndustryType = () => {
    const navigate = useNavigate();
    const [edit, setEdit] = useState(false);
    const [view, setView] = useState(false);
    const [selectedData, setSelectedData] = React.useState();
    const [isChecked, setIsChecked] = useState(false);
    const [data, setData] = useState();
    const [loading, setLoading] = useState(true);
    

    const columns = [
        {
          name: "Industry Vertical",
          selector: row => row.Name,
          sortable: true,
          cell: row => row.Name,
        },
        {
            name: "Created By",
            width: "230px",
            alignItems: "center",
            selector: row => row.CreatedBy?.name != null ? row.CreatedBy?.name : "NA",
            sortable: true,
            cell: row => row.CreatedBy?.name != null ? row.CreatedBy?.name : "NA",
        },
        {
            name: "Updated By",
            width: "230px",
            alignItems: "center",
            selector: row => row.UpdatedBy?.name != null ? row.UpdatedBy?.name : "NA",
            sortable: true,
            cell: row => row.UpdatedBy?.name != null ? row.UpdatedBy?.name : "NA",
        },
        {
            name: "Actions",
            width: "240px",
            cell: (row) => (<>
                <button className="btn btn-link ms-1" title="Edit" onClick={() => handleIndustryTypeEdit(row._id)} ><span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1.25em" width="1.25em" xmlns="http://www.w3.org/2000/svg"><path d="M19.045 7.401c.378-.378.586-.88.586-1.414s-.208-1.036-.586-1.414l-1.586-1.586c-.378-.378-.88-.586-1.414-.586s-1.036.208-1.413.585L4 13.585V18h4.413L19.045 7.401zm-3-3 1.587 1.585-1.59 1.584-1.586-1.585 1.589-1.584zM6 16v-1.585l7.04-7.018 1.586 1.586L7.587 16H6zm-2 4h16v2H4z"></path></svg></span></button>
                <button className="btn btn-link ms-1" title="Delete" onClick={() => handleButtonDelete(row._id)}><span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1.25em" width="1.25em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4z"></path></svg></span></button>
            </>),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
      ];
      
    const tableData = {
      columns,
      data,
    };

    const addIndustryType = () => {
        navigate('/industryverticaldetails', {state: {industrytypeid: null}});
    }

    const handleIndustryTypeEdit = (id) => {
        navigate('/industryverticaldetails', {state: {industrytypeid: id}});     
    }
    const BackBtn = () => {
        navigate('/home');
    }

    const handleButtonDelete = async (id) => {
        ConfirmAlert("You want to Delete Industry vertical!", 'Are you sure?', 'warning', 'Yes, delete this Industry!').then(
            async (result) => {
                if (result.isConfirmed) {
                    var response = await DeleteIndustryType(id);
                    if (response) {
                        TimerAlert("success", "Industry vertical Deleted Successfully", "success");
                        getIndustryType();
                    }
                }
            }
        )
    }

    const getIndustryType = async () => {
        let industryTypePayload = {
            Type: 3,
        }
        var industryTypeResponse = await GetIndustryType(industryTypePayload);
        setData(industryTypeResponse.data);
        setLoading(false);
    }
    const addRefresh = () => {
        navigate('/home', {state: {challengeid: null}});
    }
    useEffect(() => {
        getIndustryType();                
        setTimeout(() => {
            document.getElementById('nav-dropdownSuperadmin').parentElement.classList.add('show');
            document.getElementById('nav-dropdownSuperadmin').nextSibling.classList.add('show');
        }, 300);
    }, [])


    return (
        <div className='page'>
        {loading ? <GrokLoading /> : ""}
            <NavMenu />
            <Header />
            <div className='page-wrapper'>
                <Container fluid>
                    {/* Start Page Header */}
                    <div className='page-header d-print-none'>
                        <Row className='g-2 align-items-center pb-1'>
                            <div>
                                <Breadcrumb className="custom-breadcrumb">
                                    <Breadcrumb.Item onClick={() => addRefresh()}> Home </Breadcrumb.Item>
                                    <Breadcrumb.Item active> Industry Vertical</Breadcrumb.Item>
                                </Breadcrumb>
                            </div>
                            <Col style={{ display: 'flex', alignItems: 'center' }}>
                                <Button className='nave-icon' variant='outline' size='sm' title='Industry Vertical'>
                                    <span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path d="m21.857 8.485-3-5A.997.997 0 0 0 18 3h-4.586l-.707-.707a.999.999 0 0 0-1.414 0L10.586 3H6a.997.997 0 0 0-.857.485l-3 5A1.001 1.001 0 0 0 2.002 9H2v10a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V9h-.002c0-.178-.046-.356-.141-.515zM20 18h-6v-4h-4v4H4v-8h2.414l.293-.293 2-2L12 4.414l4.293 4.293 1 1 .293.293H20v8z"></path><circle cx="11.895" cy="9.895" r="2.105"></circle><path d="M6 12h2v3H6zm10 0h2v3h-2z"></path></svg></span>
                                </Button>
                                <h2 className="page-title"> Industry Vertical</h2>
                            </Col>
                            <Col className="mb-1 me-3 col-md-auto">
                                <button className='newBtn_style' onClick={() => BackBtn()}>
                                    <span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 512 512" height="1.5em" width="1.5em" xmlns="http://www.w3.org/2000/svg"><path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="32" d="M249.38 336L170 256l79.38-80m-68.35 80H342"></path><path fill="none" strokeMiterlimit="10" strokeWidth="32" d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"></path></svg></span>
                                    &nbsp;&nbsp;Back
                                </button>
                            </Col>
                        </Row>
                    </div>
                    {/* End Page Header */}
                    <div className='py-3'>
                        <div className='card mb-3 mb-lg-5 '>
                            {/* Header */}
                            <div className='card-header'>
                                <Row className="row justify-content-between align-items-center flex-grow-1">
                                    <Col className='col-md mb-2 md-mb-0'>
                                        <div className="d-flex justify-content-between align-items-center">
                                            {/* <div className="card-title fw-bold mb-0">Industry Type list</div> */}
                                        </div>
                                    </Col>
                                    {/* End Col */}
                                    <Col className='col-12 col-md-auto ms-auto d-print-none'>
                                        {/* <div className="form-group position-relative">
                                            <form className="d-flex mb-2 mb-md-0">
                                                <div className="form-group position-relative">
                                                    <input className="form-control leftpadding" id="text" variant="outlined" placeholder='IndustryType Name' onChange={handleName} />
                                                </div>
                                            </form>
                                        </div> */}
                                    </Col>
                                    <Col className='col-12 col-md-auto ms-auto d-print-none'>
                                        <button className="backBtn_style" onClick={() => addIndustryType()} >
                                            Add Industry Vertical
                                        </button>
                                    </Col>
                                </Row>
                                {/* End Row */}
                            </div>
                            <div className='taablist'>
                              <DataTableExtensions {...tableData}>
                                  <DataTable
                                      columns={columns}
                                      data={data}
                                      fixedHeader
                                      defaultSortField="id"
                                      defaultSortAsc={false}
                                      pagination
                                      paginationPerPage={20}
                                      paginationRowsPerPageOptions={[20, 30, 50, 100]}
                                  />
                              </DataTableExtensions>
                            </div>
                        </div>
                    </div>
                </Container>
                <Footer />
            </div>
        </div>
    )
}

export default IndustryType; 